import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { all_routes } from '../../router/all_routes';

const AllDocumentRequests = () => {
  const routes = all_routes;
  const [filterStatus, setFilterStatus] = useState('all');

  // Mock data
  const mockRequests = [
    {
      id: 1,
      requestId: 'DOC001',
      studentName: 'Alice Johnson',
      documentType: 'Transfer Certificate',
      requestDate: '2024-07-18',
      status: 'Pending',
      assignedTo: 'Admin',
      priority: 'Normal'
    },
    {
      id: 2,
      requestId: 'DOC002',
      studentName: 'Bob Smith',
      documentType: 'Character Certificate',
      requestDate: '2024-07-17',
      status: 'In Progress',
      assignedTo: 'Support',
      priority: 'High'
    },
    {
      id: 3,
      requestId: 'DOC003',
      studentName: 'Carol Davis',
      documentType: 'Bonafide Certificate',
      requestDate: '2024-07-15',
      status: 'Completed',
      assignedTo: 'Admin',
      priority: 'Normal'
    }
  ];

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Pending': return 'badge-soft-warning';
      case 'In Progress': return 'badge-soft-info';
      case 'Completed': return 'badge-soft-success';
      case 'Rejected': return 'badge-soft-danger';
      default: return 'badge-soft-secondary';
    }
  };

  const stats = {
    total: mockRequests.length,
    pending: mockRequests.filter(r => r.status === 'Pending').length,
    inProgress: mockRequests.filter(r => r.status === 'In Progress').length,
    completed: mockRequests.filter(r => r.status === 'Completed').length
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.supportDashboard}>Support Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">All Document Requests</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Stats */}
          <div className="row">
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-lg bg-primary-transparent me-3">
                      <i className="ti ti-file-text"></i>
                    </div>
                    <div>
                      <h4>{stats.total}</h4>
                      <p className="text-muted mb-0">Total Requests</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-lg bg-warning-transparent me-3">
                      <i className="ti ti-clock"></i>
                    </div>
                    <div>
                      <h4>{stats.pending}</h4>
                      <p className="text-muted mb-0">Pending</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-lg bg-info-transparent me-3">
                      <i className="ti ti-progress"></i>
                    </div>
                    <div>
                      <h4>{stats.inProgress}</h4>
                      <p className="text-muted mb-0">In Progress</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="avatar avatar-lg bg-success-transparent me-3">
                      <i className="ti ti-check"></i>
                    </div>
                    <div>
                      <h4>{stats.completed}</h4>
                      <p className="text-muted mb-0">Completed</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Requests Table */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Document Requests Overview</h4>
                  <div className="d-flex gap-2">
                    <button className="btn btn-primary btn-sm">
                      <i className="ti ti-plus me-1"></i>Manual Entry
                    </button>
                    <button className="btn btn-outline-primary btn-sm">
                      <i className="ti ti-download me-1"></i>Export
                    </button>
                  </div>
                </div>

                <div className="card-body border-bottom">
                  <div className="row g-3">
                    <div className="col-md-4">
                      <label className="form-label">Search Requests</label>
                      <input type="text" className="form-control" placeholder="Search by student, document type..." />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Filter by Status</label>
                      <select 
                        className="form-select"
                        value={filterStatus}
                        onChange={(e) => setFilterStatus(e.target.value)}
                      >
                        <option value="all">All Status</option>
                        <option value="Pending">Pending</option>
                        <option value="In Progress">In Progress</option>
                        <option value="Completed">Completed</option>
                        <option value="Rejected">Rejected</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Filter by Type</label>
                      <select className="form-select">
                        <option>All Types</option>
                        <option>Transfer Certificate</option>
                        <option>Character Certificate</option>
                        <option>Bonafide Certificate</option>
                      </select>
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">&nbsp;</label>
                      <button className="btn btn-outline-secondary w-100">
                        <i className="ti ti-filter me-1"></i>Reset
                      </button>
                    </div>
                  </div>
                </div>

                <div className="card-body border-bottom">
                  <div className="alert alert-info">
                    <h6><i className="ti ti-info-circle me-2"></i>TODO: Connect to document requests API</h6>
                    <ul className="mb-0">
                      <li>Fetch all document requests from database</li>
                      <li>Support team workflow management</li>
                      <li>Bulk operations and reporting</li>
                    </ul>
                  </div>
                </div>

                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>Request ID</th>
                          <th>Student</th>
                          <th>Document Type</th>
                          <th>Request Date</th>
                          <th>Assigned To</th>
                          <th>Priority</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {mockRequests.map((request) => (
                          <tr key={request.id}>
                            <td>
                              <Link to="#" className="text-primary fw-semibold">
                                {request.requestId}
                              </Link>
                            </td>
                            <td>{request.studentName}</td>
                            <td>{request.documentType}</td>
                            <td>{request.requestDate}</td>
                            <td>
                              <span className="badge bg-light text-dark">
                                {request.assignedTo}
                              </span>
                            </td>
                            <td>
                              <span className={`badge ${
                                request.priority === 'High' ? 'badge-soft-danger' :
                                request.priority === 'Normal' ? 'badge-soft-primary' :
                                'badge-soft-success'
                              }`}>
                                {request.priority}
                              </span>
                            </td>
                            <td>
                              <span className={`badge ${getStatusColor(request.status)}`}>
                                {request.status}
                              </span>
                            </td>
                            <td>
                              <div className="dropdown">
                                <button className="btn btn-white btn-sm dropdown-toggle" data-bs-toggle="dropdown">
                                  Actions
                                </button>
                                <ul className="dropdown-menu">
                                  <li><button className="dropdown-item"><i className="ti ti-eye me-2"></i>View Details</button></li>
                                  <li><button className="dropdown-item"><i className="ti ti-user me-2"></i>Reassign</button></li>
                                  <li><button className="dropdown-item"><i className="ti ti-edit me-2"></i>Update Status</button></li>
                                  <li><button className="dropdown-item"><i className="ti ti-message me-2"></i>Contact Student</button></li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AllDocumentRequests;
